import styled from 'styled-components';
import Button from '@mui/material/Button';

export const Container = styled(Button)`
  // margin: ${props => props.theme.spacing(3, 0, 2)};
  text-transform: none;
`;
